// constants.js

const useConstants = () => {
  const per_page = 10;
  const sql_date_format = "YYYY-MM-DD";

  const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN;
  const WORKER_APP_DOMAIN = process.env.REACT_APP_WORKER_APP_DOMAIN;
  const APP_ENV = process.env.REACT_APP_APP_ENV;

  // var AUTH_API_URL = process.env.REACT_APP_ULM_API_URL;
  // var ADMIN_URL = process.env.REACT_APP_AAM_APP_URL;
  // var HUMAN_URL = process.env.REACT_APP_HUMAN_APP_URL;
  // var AUTH_URL = process.env.REACT_APP_ULM_APP_URL;

  var AUTH_API_URL = `http://127.0.0.1:8000/api`;
  var SWM_API_URL = `http://127.0.0.1:8016/api`;
  var ADMIN_URL = `http://localhost:3001`;
  var HUMAN_URL = `http://localhost:3002`;
  var AUTH_URL = `http://localhost:3000`;
  var ERM_APP_URL = `http://localhost:3005`;

  if (APP_ENV === "production") {
    AUTH_API_URL = `https://${APP_DOMAIN}/api`;
    SWM_API_URL = `https://swm.${WORKER_APP_DOMAIN}/api`;
    ADMIN_URL = `https://administrator.${APP_DOMAIN}`;
    HUMAN_URL = `https://human.${APP_DOMAIN}`;
    AUTH_URL = `https://${APP_DOMAIN}`;
    ERM_APP_URL = `https://account.${APP_DOMAIN}`;
  } else if (APP_ENV === "development") {
    AUTH_API_URL = `${AUTH_URL}/api`;
    SWM_API_URL = `http://swm.${WORKER_APP_DOMAIN}/api`;
    ADMIN_URL = `http://administrator.${APP_DOMAIN}`;
    HUMAN_URL = `http://human.${APP_DOMAIN}`;
    AUTH_URL = `http://${APP_DOMAIN}`;
    ERM_APP_URL = `http://account.${APP_DOMAIN}`;
  }

  return {
    per_page,
    sql_date_format,
    AUTH_API_URL,
    ADMIN_URL,
    AUTH_URL,
    HUMAN_URL,
    SWM_API_URL,
    ERM_APP_URL,
  };
};

export default useConstants;
